<template>
  <div class="w-full sm:max-w-xl self-center flex flex-1 flex-col items-center">
    <h3 class="font-bold my-3 sm:text-2xl">{{ $t('homePage.confirm_delete') }}</h3>
    <img
      class="mt-auto sm:w-3/5"
      :src="brandAsset(illustration, illustrationSanne)"
      :alt="$t('homePage.confirm_delete')"
    />
    <div class="w-full flex mt-auto mb-5 justify-around">
      <c-button width="40%" secondary class="my-3" @click="$emit('confirm')">
        <span>{{ $t('homePage.delete_account') }}</span>
      </c-button>
      <c-button width="40%" class="my-3" @click="$emit('cancel')">
        <span>{{ $t('homePage.cancel_delete') }}</span>
      </c-button>
    </div>
  </div>
</template>

<script>
import brandMode from '@/mixins/brand-mode';
import CButton from '@/components/common/CButton.vue';
import illustration from '@/assets/common/delete_account.svg';
import illustrationSanne from '@/assets/sanne/delete-account-illustration.svg';

export default {
  name: 'DeleteAccount',
  components: {
    CButton,
  },
  mixins: [brandMode],
  data: () => ({ illustration, illustrationSanne }),
};
</script>
